module.exports = __webpack_public_path__ + "img/xinwen_img_02.55a88bab.jpg";